import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, concatMap, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';

import { PaymentSourceService } from '../../../../order/services';
import { AnalyticsCustomEvents } from '../../../../shared/enums/analytics-custom-events';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { DiamondCartFacadeService } from '../../../services/diamond-cart-facade.service';
import * as shoppingCartActions from '../actions/shopping-cart.actions';
import { getShippingMethod, ZingState } from '../reducers/shopping-cart.reducer';

@Injectable()
export class ShoppingCartEffects {

  constructor(
    private actions$: Actions,
    private shoppingCartFacade: DiamondCartFacadeService,
    private store: Store<ZingState>,
    private analyticsService: AnalyticsService,
    private paymentSourceService: PaymentSourceService
  ) { }

  checkout$: Observable<Action> = createEffect(() => this.actions$
    .pipe(
      ofType(shoppingCartActions.ShoppingCartActionTypes.Checkout),
      concatMap(({ payload }: shoppingCartActions.Checkout) => of(payload.paymentMethod).pipe(
        withLatestFrom(
          this.store.pipe(select(getShippingMethod))
        )
      )),
      switchMap(([paymentMethod, shippingMethod]) =>
        this.shoppingCartFacade.checkout(paymentMethod, shippingMethod)
          .pipe(
            tap(() =>
              this.analyticsService.eventTrackAI(`${AnalyticsCustomEvents.DiamondOrderCompleted}-Success`)
            ),
            map(() => new shoppingCartActions.CheckoutSuccess()),
            catchError(err => {
              this.analyticsService.eventTrackAI(`${AnalyticsCustomEvents.DiamondOrderCompleted}-Error`);
              return of(new shoppingCartActions.CheckoutFail(err));
            })
          )
      )
    ));

  fetchPaymentInformation$: Observable<Action> = createEffect(() => this.actions$
    .pipe(
      ofType(shoppingCartActions.ShoppingCartActionTypes.FetchPaymentInformation),
      switchMap(({ payload: { zingOrderId } }: shoppingCartActions.FetchPaymentInformation) =>
        this.paymentSourceService.getByOrderId(zingOrderId)
          .pipe(
            map(paymentSource => new shoppingCartActions.FetchPaymentInformationSuccess(paymentSource)),
            catchError(err => of(new shoppingCartActions.FetchPaymentInformationFail(err)))
          )
      )));
}
